// THE PATHS IN THIS FILE ARE AUTOMATICALLY CHANGED IN DOCKER DEPLOYMENT CONFIGURATION

export const BACKEND_URL = 'https://backend.bert-vs-gpt2.dbvis.de';
